export default __webpack_public_path__ + "static/media/self-delivery-area.75307216.png";